var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotificationAchievements = function SvgNotificationAchievements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z",
    fill: "url(#notificationAchievements_svg__dvovmr5l8a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.475 32.586a2 2 0 01-2.629-2.541l4.16-11.384c.495-1.36 2.107-1.162 3.268-.752a11.171 11.171 0 014.38 2.732 8.714 8.714 0 012.698 4.11c.379 1.262.701 2.75-.64 3.292l-11.237 4.543zm7.043-20.551a1 1 0 00-1.999.07l.07 1.999a1 1 0 002-.07l-.07-2zm6.449 5.034a1 1 0 00-1.414-1.415l-1.415 1.415a1 1 0 001.415 1.414l1.414-1.414zm3.493 7.082a1 1 0 00.175-1.992l-1.993-.174a1 1 0 00-.174 1.992l1.993.174z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "notificationAchievements_svg__dvovmr5l8a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 17.28) scale(26.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgNotificationAchievements;